import React, { Dispatch } from 'react';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast, SuccessToast } from 'components/Toast';
import { STRINGS } from 'config';

const {
  REDUCERS: { TOOLBAR: { GET_CURRENT_PATIENT_REQUEST, GET_CURRENT_PATIENT_RESPONSE, GET_CURRENT_PATIENT_FAILED } },
} = STRINGS;

export const triggerToolbarGetCurrentPatient = async (dispatch: Dispatch<unknown>): Promise<void> => {
  dispatch({ type: GET_CURRENT_PATIENT_REQUEST });
  try {
    await fetch(`${window.location.protocol}//toolbar/getcurrentpatient`, {
      method: 'GET',
      credentials: 'include',
    });
  } catch (error) {
    // This call will always fail by design.
  }
};

/*
    Toolbar status meaning
    500 - a general error
    401 - the user isn't logged into the clinical system
    403 - the user doesn't have the right access rights in the clinical system
    404 - there isn't a patient open in the clinical system
*/
interface GetCurrentPatientResponse {
  status: number;
  patientId: string;
  nhsNumber: string;
  firstName: string;
  surname: string;
  dateOfBirth: string;
  postcode: string;
  gender: string;
}

export const injectGetCurrentPatientResponse = (dispatch: React.Dispatch<unknown>) => (response: GetCurrentPatientResponse): unknown => {
  if (response.status === 200) {
    dispatch({
      type: GET_CURRENT_PATIENT_RESPONSE,
      payload: response,
    });
    return toast.success(
      React.createElement(SuccessToast, {
        message: 'Successfully retrieved current patient information.',
      }), { icon: false },
    );
  }
  dispatch({
    type: GET_CURRENT_PATIENT_FAILED,
    payload: response,
  });

  const errorMessage = {
    401: 'You are not logged in to the clinical system.',
    403: 'You do not have the correct permissions in the clinical system.',
    404: 'No patient record is open in the clinical system.',
  };

  return toast.error(
    React.createElement(ErrorToast, {
      message: errorMessage[response.status as keyof typeof errorMessage] ?? 'Failed to retrieve current patient information.',
    }),
    {
      autoClose: 12000,
      pauseOnHover: true,
      hideProgressBar: false,
      closeOnClick: true,
      icon: false,
    },
  );
};
